var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0FBBE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.5 25.5V28.5C34.5 30.16 33.16 31.5 31.5 31.5H30.5C30.5 30.4 29.6 29.5 28.5 29.5C27.4 29.5 26.5 30.4 26.5 31.5H22.5C22.5 30.4 21.6 29.5 20.5 29.5C19.4 29.5 18.5 30.4 18.5 31.5H17.5C15.84 31.5 14.5 30.16 14.5 28.5V25.5H25.5C26.6 25.5 27.5 24.6 27.5 23.5V16.5H29.34C30.06 16.5 30.72 16.89 31.08 17.51L32.79 20.5H31.5C30.95 20.5 30.5 20.95 30.5 21.5V24.5C30.5 25.05 30.95 25.5 31.5 25.5H34.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 33.5C21.6046 33.5 22.5 32.6046 22.5 31.5C22.5 30.3954 21.6046 29.5 20.5 29.5C19.3954 29.5 18.5 30.3954 18.5 31.5C18.5 32.6046 19.3954 33.5 20.5 33.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 33.5C29.6046 33.5 30.5 32.6046 30.5 31.5C30.5 30.3954 29.6046 29.5 28.5 29.5C27.3954 29.5 26.5 30.3954 26.5 31.5C26.5 32.6046 27.3954 33.5 28.5 33.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 24.03V25.5H31.5C30.95 25.5 30.5 25.05 30.5 24.5V21.5C30.5 20.95 30.95 20.5 31.5 20.5H32.79L34.24 23.04C34.41 23.34 34.5 23.68 34.5 24.03Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 13.5H18.5C16.55 13.5 14.93 14.9 14.58 16.75H19.5C19.91 16.75 20.25 17.09 20.25 17.5C20.25 17.91 19.91 18.25 19.5 18.25H14.5V19.75H17.5C17.91 19.75 18.25 20.09 18.25 20.5C18.25 20.91 17.91 21.25 17.5 21.25H14.5V22.75H15.5C15.91 22.75 16.25 23.09 16.25 23.5C16.25 23.91 15.91 24.25 15.5 24.25H14.5V25.5H25.5C26.6 25.5 27.5 24.6 27.5 23.5V14.5C27.5 13.95 27.05 13.5 26.5 13.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 16.75H13.5C13.09 16.75 12.75 17.09 12.75 17.5C12.75 17.91 13.09 18.25 13.5 18.25H14.5V17.5C14.5 17.24 14.53 16.99 14.58 16.75Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.75C13.09 19.75 12.75 20.09 12.75 20.5C12.75 20.91 13.09 21.25 13.5 21.25H14.5V19.75H13.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.75C13.09 22.75 12.75 23.09 12.75 23.5C12.75 23.91 13.09 24.25 13.5 24.25H14.5V22.75H13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.11e3789ffe4d851833b48611e43563a1.svg";
export { ForwardRef as ReactComponent };